/**
 * i18n login namespace
 * Consist of English and arabic translations
 */
export const loginNameSpace = {
  en: {
    LOGIN_PAGE: "Login Page",
    USER_NAME: "username",
    REQUIRED_EMAIL: "Please input your email!",
    VALID_EMAIL: "Please enter a valid email!",
    PASSWORD: "password",
    REQUIRED_PASSWORD: "Please input your Password!",
    MIN_LENGTH_PASSWORD: "Password should be at least 8 character long!",
    FORGOT_PASSWORD: "Forgot password?",
    REMEMBER_ME: "Remember Me",
    LOG_IN: "Log In",
    OR: "OR",
    REGISTER_NOW: "register now!",
  },
  ar: {
    LOGIN_PAGE: "صفحة تسجيل الدخول",
    USER_NAME: "اسم المستخدم",
    REQUIRED_EMAIL: "الرجاء ادخال البريد الالكتروني",
    VALID_EMAIL: "الرجاء التحقق من صحة البريد الالكتروني",
    PASSWORD: "كلمة المرور",
    REQUIRED_PASSWORD: "الرجاء ادخال كلمة المرور",
    MIN_LENGTH_PASSWORD: "ينبغي ان تتألف كلمة المرور من ثمانية احرف فأكثر",
    FORGOT_PASSWORD: "نسيت كلمة المرور؟",
    REMEMBER_ME: "تذكر بياناتي",
    LOG_IN: "تسجيل الدخول",
    OR: "او",
    REGISTER_NOW: "قم بالتسجيل الان",
  },
};
